var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item pb-3 mb-3 border-bottom col-12",
      attrs: { id: "gallery__item-" + _vm.element.id }
    },
    [
      _c(
        "transition",
        { attrs: { mode: "out-in", name: "slide" } },
        [
          !_vm.isEdit
            ? _c(
                "div",
                { staticClass: "row" },
                [
                  _c("div", { staticClass: "col-12" }, [
                    _vm.element.name
                      ? _c("h2", [_vm._v(_vm._s(_vm.element.name))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("CoolLightBox", {
                        attrs: { index: _vm.index, items: _vm.lightBoxImages },
                        on: {
                          close: function($event) {
                            _vm.index = null
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "images-list" },
                        [
                          _c(
                            "draggable",
                            {
                              staticClass: "images-wrapper row",
                              attrs: {
                                disabled: !_vm.enabled,
                                "ghost-class": "ghost"
                              },
                              on: {
                                start: function($event) {
                                  _vm.dragging = true
                                },
                                end: function($event) {
                                  return _vm.dragStop()
                                }
                              },
                              model: {
                                value: _vm.lightBoxImages,
                                callback: function($$v) {
                                  _vm.lightBoxImages = $$v
                                },
                                expression: "lightBoxImages"
                              }
                            },
                            _vm._l(_vm.lightBoxImages, function(
                              image,
                              imageIndex
                            ) {
                              return _c(
                                "div",
                                {
                                  key: imageIndex,
                                  staticClass: "col-2",
                                  on: {
                                    click: function($event) {
                                      _vm.index = imageIndex
                                    }
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "image",
                                    class: image.thumbnail
                                      ? "border border-success"
                                      : "",
                                    style: {
                                      backgroundImage: "url(" + image.src + ")"
                                    },
                                    attrs: { "data-sort": imageIndex }
                                  })
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-8 d-flex flex-row align-items-center" },
                    [
                      _c("div", { staticClass: "img-sort-help mt-3" }, [
                        _c("i", { staticClass: "fas fa-info-circle" }),
                        _vm._v(" " + _vm._s(this.help) + "\n                ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("buttons", {
                    attrs: { isLoading: _vm.isLoading },
                    on: {
                      delete: function($event) {
                        return _vm.deleteItem(_vm.element.id)
                      },
                      edit: function($event) {
                        _vm.isEdit = true
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEdit
            ? _c("gallery-form", {
                attrs: {
                  item: _vm.element,
                  "national-service-options": _vm.nationalServiceOptions,
                  url: this.url,
                  "axios-method": "PATCH"
                },
                on: {
                  addItem: _vm.updateItem,
                  cancelNew: function($event) {
                    _vm.isEdit = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }